"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var __1 = require("../");
var RiskModal_1 = __importDefault(require("../../Common/RiskModal"));
var SecurityUpdateIcon_1 = __importDefault(require("../Icons/SecurityUpdateIcon"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountStyles_1 = require("../VerifyAccountStyles");
var TwoFactorModalContent_1 = __importDefault(require("./TwoFactorModalContent"));
var TwoFactorAuthentication = function (_a) {
    var action = _a.action, blockChannelSwitch = _a.blockChannelSwitch, channel = _a.channel;
    return (React.createElement(RiskModal_1["default"], { title: TwoFactorAuthenticationStrings_1["default"].twoStepVerification(), renderContentHeader: function (_a) {
            var title = _a.title;
            return (React.createElement(VerifyAccountStyles_1.TitleContainer, null,
                React.createElement(design_language_1.StackChildren, null,
                    React.createElement(VerifyAccountStyles_1.SecurityIconContainer, null,
                        React.createElement(SecurityUpdateIcon_1["default"], { size: design_language_1.Icon.Sizes.XLarge, color: design_language_1.Colors.SystemWhite })),
                    React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageTitle, textAlign: design_language_1.Text.TextAlignments.Center }, title))));
        } }, function () { return (React.createElement(__1.VerifyAccountProvider, { action: action, blockChannelSwitch: blockChannelSwitch, channel: channel },
        React.createElement(TwoFactorModalContent_1["default"], null))); }));
};
exports["default"] = TwoFactorAuthentication;
